module.exports = __webpack_public_path__ + "img/sidebar-logo.53f039ce.png";